declare namespace $ {

	type $mol_check__aria_role_shm_hitalama_skills_item_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check['aria_role'] >
	>
	type $mol_check__checked_shm_hitalama_skills_item_2 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_check__click_shm_hitalama_skills_item_3 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_check['click'] >
	>
	type $mol_check__sub_shm_hitalama_skills_item_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_item['anchor_content'] >
		,
		ReturnType< $mol_check['sub'] >
	>
	type $mol_view__sub_shm_hitalama_skills_item_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_skills_item_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pick__align_shm_hitalama_skills_item_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__Anchor_shm_hitalama_skills_item_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_item['Anchor'] >
		,
		ReturnType< $mol_pick['Anchor'] >
	>
	type $mol_pick__event_shm_hitalama_skills_item_9 = $mol_type_enforce<
		({ 
			contextmenu( next?: ReturnType< $shm_hitalama_skills_item['contextmenu'] > ): ReturnType< $shm_hitalama_skills_item['contextmenu'] >,
		})  & ReturnType< $mol_pick['event'] >
		,
		ReturnType< $mol_pick['event'] >
	>
	type $mol_pick__bubble_content_shm_hitalama_skills_item_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_item['menu_content'] >
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_button_minor__title_shm_hitalama_skills_item_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_skills_item_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_item['rename_start'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_skills_item_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_skills_item_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_item['add_skill'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_skills_item_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_skills_item_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_item['add_group'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $shm_confirm_delete__title_shm_hitalama_skills_item_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_item['delete_title'] >
		,
		ReturnType< $shm_confirm_delete['title'] >
	>
	type $shm_confirm_delete__question_shm_hitalama_skills_item_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_item['delete_question'] >
		,
		ReturnType< $shm_confirm_delete['question'] >
	>
	type $shm_confirm_delete__confirmed_shm_hitalama_skills_item_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_item['remove'] >
		,
		ReturnType< $shm_confirm_delete['confirmed'] >
	>
	type $mol_check__aria_role_shm_hitalama_skills_item_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check['aria_role'] >
	>
	type $mol_check__checked_shm_hitalama_skills_item_21 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_check__event_shm_hitalama_skills_item_22 = $mol_type_enforce<
		({ 
			dblclick( next?: ReturnType< $shm_hitalama_skills_item['rename_start'] > ): ReturnType< $shm_hitalama_skills_item['rename_start'] >,
		})  & ReturnType< $mol_check['event'] >
		,
		ReturnType< $mol_check['event'] >
	>
	type $mol_check__sub_shm_hitalama_skills_item_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_check['sub'] >
	>
	type $mol_link__arg_shm_hitalama_skills_item_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_item['link_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_shm_hitalama_skills_item_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_string__value_shm_hitalama_skills_item_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_item['draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_hitalama_skills_item_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_skills_item['rename_submit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_hitalama_skills_item_28 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_hitalama_skills_item['rename_submit'] > ): ReturnType< $shm_hitalama_skills_item['rename_submit'] >,
			keydown( next?: ReturnType< $shm_hitalama_skills_item['rename_keydown'] > ): ReturnType< $shm_hitalama_skills_item['rename_keydown'] >,
			pointerdown( next?: ReturnType< $shm_hitalama_skills_item['input_pointerdown'] > ): ReturnType< $shm_hitalama_skills_item['input_pointerdown'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	export class $shm_hitalama_skills_item extends $mol_view {
		content( ): readonly($mol_view)[]
		anchor_content( ): readonly($mol_view)[]
		Anchor( ): $mol_check
		contextmenu( next?: any ): any
		menu_content( ): readonly($mol_view)[]
		rename_start( next?: any ): any
		delete_title( ): string
		delete_question( ): string
		remove( next?: any ): any
		Folder_icon( ): $mol_icon_folder
		title( ): string
		link_arg( ): Record<string, any>
		Link_title( ): $mol_view
		skill_id( ): string
		Link_id( ): $mol_view
		draft( next?: string ): string
		rename_submit( next?: any ): any
		rename_keydown( next?: any ): any
		input_pointerdown( next?: any ): any
		entry( ): $shm_hitalama_skills_entry
		catalog( ): $shm_hitalama_skills_catalog
		add_skill( next?: any ): any
		add_group( next?: any ): any
		sub( ): ReturnType< $shm_hitalama_skills_item['content'] >
		Menu( ): $mol_pick
		Rename( ): $mol_button_minor
		Add_skill( ): $mol_button_minor
		Add_group( ): $mol_button_minor
		Delete( ): $shm_confirm_delete
		Group( ): $mol_check
		Link( ): $mol_link
		Input( ): $mol_string
	}
	
}

//# sourceMappingURL=item.view.tree.d.ts.map